<script setup>
import { storage } from '../storage'
import { galaxies } from '../staticData'

import ModalBlock from './ModalBlock'
defineEmits(['hide-list'])

function getPinkAward(ind) {
    return Math.ceil(5 + (3 * (ind - 1)))
}
function getBlackAward(ind) {
    return Math.ceil(1 + (1.5 * (ind - 1)))
}

</script>

<template>
    <ModalBlock @closeWindow="$emit('hide-list')" :class="'main-block-all'">
        <template #header>
            <h3>All Galaxies</h3>
        </template>
        <template #main>
            <div class="column-list">
                <div v-for="(g, ind) in galaxies" :key="'galaxy-' + ind" class="item" :class="{ 'completed': storage.GALAXY_IND >= ind }">
                    <p>{{ g.name }} </p>
                    <span v-if="storage.GALAXY_IND >= ind">{{ 'REACHED' }}</span>
                    <div class="award" v-else>
                        <p>
                            <img class="coin-sm" src="/spacebar-clicker/assets/balls/ball_1.png" alt="" >{{ getPinkAward(ind) }}
                        </p>
                        <p>
                            <img class="coin-sm" src="/spacebar-clicker/assets/balls/ball_9.png" alt="" >{{ getBlackAward(ind) }}
                        </p>
                    </div>
                    <!-- <p v-else class=""><img class="coin-sm" :src="getCoinUrl()" alt="">{{ stringNumber(g.distance, true) }}</P> -->
                </div>
            </div>
        </template>
    </ModalBlock>
</template>

<style scoped>
.award {
    margin-left: 10px;
    width: 100px;
    display: flex;
    /* justify-content: space-between; */
}

.award p {
    width: 50%;
}

.column-list .item {
    width: 100%;
    min-width: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.699);
}

.item.completed {
    /* box-shadow: 0px 0px 8px 6px rgba(0, 0, 0, 0.68); */
    border-bottom: 1px solid #b51313
}

.item span {
    color: #b51313;
}
</style>